/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportInstallationsContent from "./ImportInstallationsContent";
import { ROUTE_COMPRESSORS_IMPORT } from "../../../../routes";

export default class extends Component {
  static propTypes = ImportInstallationsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Pour réaliser l'import de vos installations, les données doivent être
          enregistrées au format ODS ou TSV, et respecter la structure suivante:
        </p>

        <ul>
          <li>N° client <i>(optionnel) - Si une ligne d'installation ne possède pas de n° client, l'installation sera créée pour le compte client auquel vous êtes attaché.</i></li>
          <li>N° site</li>
          <li>N° installation</li>
          <li>
            Fluide
          </li>
          <li>
            Huile <i>(optionnel)</i>
          </li>
          <li>
            Caloporteur <i>(optionnel)</i>
          </li>
          <li>Désignation</li>
          <li>Charge nominale</li>
          <li>Charge actuelle</li>
          <li>
            Identifiant num <i>(optionnel)</i>
          </li>
          <li>Repère</li>
          <li>Date de mise en service</li>
          <li>Date du dernier contrôle périodique</li>
          <li>
            Détecteur de fuite indirect <i>(0 = pas de détecteur | 1 = présence d'un détecteur)</i>
          </li>
        </ul>
        <small>Champs requis uniquement pour l'ajout d'un compresseur sur l'installation :</small>
        <ul>
          <li>Compresseur : Repère</li>
          <li>Compresseur : Identifiant num <i>(optionnel)</i></li>
          <li>Compresseur : N° série</li>
          <li>Compresseur : Type <i>(optionnel)</i></li>
          <li>Compresseur : Genre <i>(optionnel)</i></li>
          <li>Compresseur : Marque</li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Pour importer plusieurs compresseurs sur une même installations, <a href={ROUTE_COMPRESSORS_IMPORT}>cliquez ici</a>.
        </p>

        <p>
          Après l'intégration, une synthèse vous informera sur le nombre
          d'entités créées ou mises à jour, et mettra à disposition un fichier
          d'anomalies contenant les lignes non intégrées, et le(s) motif(s) du
          rejet.
        </p>

        <p>Les motifs d'anomalie possibles sont:</p>

        <ul>
          <li>Absence de données obligatoires</li>
          <li>Fluide, huile ou caloporteur inexistant</li>
          <li>Valeur du top différent de 1/0</li>
          <li>Date invalide</li>
          <li>Type, genre ou marque de compresseur inexistant</li>
        </ul>
      </div>
    );
  }
}
